// @ts-expect-error not typed
import { hasAccessToBusinessUnit } from 'EmailData/selectors/user';
import { CONTENT_TEAM_ASSIGNMENT, TEAMS_CONTENT_PARTITIONING } from 'EmailData/constants/teams';
import { getCanViewApprovals } from 'EmailData/selectors/approvals';
import { PROPERTIES, PROPERTIES_TO_HIDE, PROPERTIES_TO_HIDE_ONLY_IN_FILTERS } from 'email-management-lib/Shared/constants/frameworkTable';
import FrameworkCampaignFilter from 'email-management-lib/refactor/components/manage/frameworkTable/filters/FrameworkCampaignFilter';
import FrameworkEmailTypeFilter from 'email-management-lib/refactor/components/manage/frameworkTable/filters/FrameworkEmailTypeFilter';
import FrameworkSubscriptionFilter from 'email-management-lib/refactor/components/manage/frameworkTable/filters/FrameworkSubscriptionFilter';
import { OVERRIDE_PROPERTY_CONTEXT, PROPERTIES_TO_SHOW_IN_COLUMNS_AND_FILTERS, PROPERTIES_TO_SHOW_ONLY_IN_FILTERS } from 'email-management-lib/refactor/components/manage/frameworkTable/overrideProperties';
import getShouldHidePublishStatusFilter from 'email-management-lib/refactor/utils/getShouldHidePublishStatusFilter';
import ListingLibUsersAndTeamsSelect from 'framework-listing-lib/filters/ListingLibUsersAndTeamsSelect';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useHasBusinessUnitsRebrand } from 'ui-business-units-lib/hooks/useHasBusinessUnitsRebrand';
import FrameworkListingLibFiltersBar from './FrameworkListingLibFilterBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QUICK_FILTER_PROPS = {
  propertyNames: [PROPERTIES.CAMPAIGN_GUID, PROPERTIES.EMAIL_TYPE, PROPERTIES.TEAM_IDS, PROPERTIES.USER_IDS, PROPERTIES.SUBSCRIPTION]
};
export default function FrameworkTableFilters() {
  const {
    state: viewUrl
  } = useParams();
  const shouldHidePublishStatusFilter = useMemo(() => {
    return getShouldHidePublishStatusFilter(viewUrl);
  }, [viewUrl]);
  const canAccessBusinessUnit = useSelector(hasAccessToBusinessUnit);
  // @ts-expect-error Property 'get' does not exist on type 'DefaultRootState'.
  const user = useSelector(state => state.get('user'));
  const canViewApprovals = useSelector(getCanViewApprovals);
  const hasFullDashboardAccess = user.hasFullDashboardAccess();
  const hasBusinessUnitsRebrand = useHasBusinessUnitsRebrand();
  const propertyOverride = useMemo(() => {
    return {
      propertyMap: Object.assign({}, PROPERTIES_TO_SHOW_IN_COLUMNS_AND_FILTERS({
        canViewApprovals
      }), OVERRIDE_PROPERTY_CONTEXT({
        canAccessBusinessUnit,
        hasBusinessUnitsRebrand
      }), PROPERTIES_TO_HIDE, PROPERTIES_TO_HIDE_ONLY_IN_FILTERS, PROPERTIES_TO_SHOW_ONLY_IN_FILTERS(), {
        [PROPERTIES.PUBLISH_STATUS]: {
          hidden: shouldHidePublishStatusFilter
        }
      })
    };
  }, [canAccessBusinessUnit, canViewApprovals, hasBusinessUnitsRebrand, shouldHidePublishStatusFilter]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [hasFullDashboardAccess && /*#__PURE__*/_jsx(FrameworkCampaignFilter, {}), /*#__PURE__*/_jsx(FrameworkEmailTypeFilter, {}), hasFullDashboardAccess && /*#__PURE__*/_jsx(ListingLibUsersAndTeamsSelect, {
      use: "button",
      viewAllAssetsScope: CONTENT_TEAM_ASSIGNMENT,
      viewTeamOwnedAssetsScope: TEAMS_CONTENT_PARTITIONING
    }), hasFullDashboardAccess && /*#__PURE__*/_jsx(FrameworkSubscriptionFilter, {}), /*#__PURE__*/_jsx(FrameworkListingLibFiltersBar, {
      propertyOverride: propertyOverride,
      externalQuickFilterPropertyNames: QUICK_FILTER_PROPS.propertyNames
    })]
  });
}